<template>
<div>
    <div class="tabs mb-5">
        <div class="tabs-header">
            <div
                :class="['tabs-header-item', { active: active_tab === 'users' }]"
                @click="active_tab = 'users'">
                User Accounts
            </div>

            <div
                :class="['tabs-header-item', { active: active_tab === 'tenants' }]"
                @click="active_tab = 'tenants'">
                Tenant Accounts
            </div>
        </div>

        <div class="tabs-content">
            <div v-if="active_tab === 'users'">
                <UserAccountsTab />
            </div>

            <div v-else>
                <TenantAccountsTab />
            </div>
        </div>
    </div>
</div>
</template>

<script>
import UserAccountsTab from "@/components/manage-users-page/UserAccountsTab"
import TenantAccountsTab from "@/components/manage-users-page/TenantAccountsTab"

export default {
    name: "manage-users-page",

    components: {
        UserAccountsTab,
        TenantAccountsTab
    },

    data () {
        return {
            active_tab: "users"
        }
    }
}
</script>

<style scoped>
.activity-dot {
    background: #ccc;
    border-radius: 100%;
    display: inline-block;
    height: 15px;
    vertical-align: middle;
    width: 15px;
}

.activity-dot.active {
    background: #a1f5ce;
}

.activity-dot.recent {
    background: #a0d2f5;
}

.activity-dot.rogue {
    background: #f3a384;
}
</style>



// WEBPACK FOOTER //
// src/pages/admin/ManageUsersPage.vue